import Decimal from 'decimal.js'

import { format, NumericFormatterConfig } from '@/utils/numeric'

type NumericOutputProps = NumericFormatterConfig & { value?: Decimal.Value | null | undefined }

/**
 * A wrapper of the {@link format} method from numeric utility.
 */
const NumericOutput = ({ value, ...props }: NumericOutputProps) => {
  return <>{format(value, props)}</>
}

export default NumericOutput
